import { intlFormat, parseISO } from 'date-fns'
import { TimeHTMLAttributes, useEffect, useState } from 'react'

export interface TimeDisplayProps
  extends TimeHTMLAttributes<HTMLElement> {
  /**
   * The date or time to display as an ISO
   * string
   *
   * eg: 2020-01-01T10:00
   */
  isoDateTime: string
  formatOptions?: Parameters<typeof intlFormat>[1]
}

export function TimeDisplay({
  isoDateTime,
  formatOptions,
  ...props
}: TimeDisplayProps) {
  const [display, setDisplay] = useState('')
  const date = parseISO(isoDateTime)
  useEffect(() => {
    setDisplay(
      intlFormat(date, {
        day: undefined,
        hour: 'numeric',
        minute: 'numeric',
        ...formatOptions,
      })
    )
  }, [isoDateTime])
  return (
    <time dateTime={isoDateTime} title={isoDateTime} {...props}>
      {display}
    </time>
  )
}
